// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width={802}
      height={156}
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 6974 1359"
      {...props}
    >
      <path
        fill="#D0D9DD"
        fillRule="nonzero"
        d="M6940 694c0 354-287 641-641 641s-641-287-641-641 287-641 641-641 641 287 641 641z"
      />
      <path
        fill="#FEFEFE"
        fillRule="nonzero"
        d="m6942 690-567 327-73-127 577-334z"
      />
      <path
        fill="#2E3C68"
        fillRule="nonzero"
        d="m6942 690-10-16-550 318-55-95 544-314 54 115 17-8-10-16 10 16 17-8-71-152-612 353 92 160 598-345-7-16z"
      />
      <path
        fill="#2E3C68"
        fillRule="nonzero"
        d="M6296 231h-2c-187 0-375 96-375 214 0 25 7 49 19 71 21 34 71 69 85 108 19 53 31 108 35 166l-77 393 321 105 341-109-111-389c4-58 16-113 35-166 14-39 64-74 85-108 12-22 19-46 19-71 0-118-188-214-375-214z"
      />
      <path
        fill="#2E3C68"
        fillRule="nonzero"
        d="m6489 1238 94-25-3-17c-1 1-3 2-4 3-21 14-54 28-87 39z"
      />
      <path
        fill="#787D7E"
        fillRule="nonzero"
        d="M6387 1270h-18l120-32c-51 19-102 32-102 32z"
      />
      <path
        fill="#2A2C44"
        fillRule="nonzero"
        d="M6369 1270h-11l214-68c-21 12-52 25-83 36l-120 32zM6671 445zm0 0v-1 1zm0-1zm0 0zm0-1zm0 0zm0-1zm0-1zm0 0zm0 0zm-91-131c-10-7-22-14-34-21 10 5 22 12 34 21z"
      />
      <path
        fill="#2A2C44"
        fillRule="nonzero"
        d="M6358 1270h-66l-54-629s340-174 280-328c-8-21-4-30 7-30 5 0 13 3 21 6 12 7 24 14 34 21 14 9 28 21 42 33 29 29 47 62 49 98v4c0 25-7 49-19 71-21 34-71 69-85 108-19 53-31 108-35 166l105 369c-1 1-42 28-56 37h-1c-1 1-3 2-4 3-2 1-3 2-4 3l-214 68z"
      />
      <path
        fill="#2A2C44"
        fillRule="nonzero"
        d="M6489 1238c31-11 62-24 83-36 1-1 2-2 4-3 1-1 3-2 4-3h1c-3 2-5 3-5 3-21 14-54 28-87 39z"
      />
      <path
        fill="#2E3C68"
        fillRule="nonzero"
        d="m6698 754-1-1c-5-6-8-13-5-18s12-7 21-4l3 1c46 14 66 25 85 40l-66 29c-10-17-22-33-37-47zM6794 704l-1-1c-6-5-9-12-6-17 2-6 11-7 21-5l3 1c46 12 66 23 87 37l-66 31c-10-16-23-32-38-46z"
      />
      <path
        fill="#EC6C2F"
        d="M6295 0c374 0 677 302 679 675v9c-2 373-305 675-679 675-375 0-680-304-680-679 0-376 305-680 680-680zm0 106c317 0 573 257 573 574 0 316-256 573-573 573s-574-257-574-573c0-317 257-574 574-574z"
      />
      <path
        fill="#FEFEFE"
        fillRule="nonzero"
        d="m6016 457 1-1-1 1zm3-64c-13 19-21 36-26 49-7 12 1 25 3 29 9 16 49 61 63 61s16-12 19-30c4-17 9-43 20-69-25-8-64-23-79-40zM6271 289c-101-1-166 26-209 59 16 7 43 19 73 31 28-28 70-50 135-54 25-2 27-15 27-19 0-6-4-17-26-17zM6664 928c0-34-12-83-70-121l-17-8c-3-6-16 80-22 89-4 5-126 55-260 55s-256-50-259-55c-6-9-20-95-22-89l-17 8c-58 38-71 87-71 121 0 171 279 186 368 186h3c89 0 367-15 367-186z"
      />
      <path
        fill="#002E6C"
        fillRule="nonzero"
        d="M5998 837c-31 25-46 55-46 91 0 149 262 161 342 161l3 25-1-25c81 0 343-12 343-161 0-36-15-66-46-91-1 2-1 4-1 5-9 41-11 52-16 59-13 19-152 59-283 59s-265-40-278-58c-5-8-8-19-16-60 0-1-1-3-1-5zm296 302c-92 0-393-16-393-211 0-40 15-98 82-142l3-1 8-5 4-8 19 2c19 2 22 14 31 58 2 11 6 29 8 38 28 13 131 48 239 48 109 0 211-35 239-48 3-9 6-27 9-38 9-44 11-56 31-58l18-2 4 8 11 6c68 44 82 102 82 142 0 195-300 211-392 211h-3z"
      />
      <path
        fill="#FEFEFE"
        fillRule="nonzero"
        d="M6647 762c0-34-12-81-68-119l-15-8c-3-6-16 79-22 87-3 5-119 54-247 55-127-1-243-50-247-55-5-8-18-93-21-87l-16 8c-55 38-67 85-67 119 0 168 265 182 350 183h2c85-1 351-15 351-183z"
      />
      <path
        fill="#2E3C68"
        fillRule="nonzero"
        d="M6520 711zm-509-36c-28 23-42 53-42 87 0 145 249 157 325 157h2c77 0 325-12 325-157 0-34-14-64-42-87v3c-8 39-11 50-16 58-13 21-149 66-268 66-118 0-254-45-268-66-4-8-7-19-15-58l-1-3zm283 295c-88-1-375-16-375-208 0-40 14-96 78-140l3-1 8-4 18-8 4 1c20 2 22 14 31 58 2 11 6 28 8 37 27 13 124 46 226 47 103-1 222-43 249-56 3-9 20-72 28-83l11 4 10 5c65 44 79 100 79 140 0 192-287 207-375 208h-3zM6268 1037l-1-1c-3-9-3-17 2-21 6-5 17-3 26 5l2 3c30 26 55 54 76 82h-87c-3-22-9-45-18-68zM6125 1020l-1-2c-3-9-1-17 4-21 7-4 17 0 25 9l2 2c28 30 50 60 67 91l-86-9c0-23-4-47-11-70zM6002 977v-2c-1-9 2-17 8-19 7-3 15 2 20 12l2 4c17 34 31 68 40 101l-76-26c5-23 7-46 6-70zM6415 1028l-1-2c-4-8-3-17 2-21 6-5 16-3 25 5l3 2c45 35 62 56 77 81l-87 2c-3-22-9-45-19-67zM6539 995l-1-2c-4-8-3-17 2-21 6-5 16-3 25 5l3 2c46 36 46 44 61 68l-71 15c-3-23-9-45-19-67z"
      />
      <path
        fill="#2E3C68"
        fillRule="nonzero"
        d="m6272 867-1-1c-3-9-3-17 2-21 6-5 17-3 26 5l2 3c30 26 55 54 76 83h-87c-3-23-9-46-18-69zM6120 847v-2c-3-9-2-17 4-20 6-5 16-1 25 8l2 3c27 29 50 59 67 90l-87-9c0-23-4-47-11-70zM6006 799v-2c0-9 4-16 9-19 7-2 16 4 21 14l1 3c17 35 30 70 37 104l-75-30c5-22 8-46 7-70zM6420 853l-1-2c-3-8-3-17 2-21 6-5 16-3 26 5l2 2c45 35 62 56 78 81l-87 2c-3-22-10-45-20-67zM6541 815l-1-1c-4-9-3-17 2-21 6-6 16-3 25 4l3 3c46 35 46 44 61 68l-72 15c-2-23-9-46-18-68zM445 297C166 297 0 448 0 700c0 292 240 396 446 396 97 0 162-14 218-27l-7-122c-49 17-114 33-183 33-176 0-295-112-295-280 0-169 114-287 278-287 67 0 129 14 193 45l12-125c-61-17-138-36-217-36zM1064 988c-113 0-154-110-154-213 0-133 58-213 154-213s153 80 153 213c0 103-40 213-153 213zm0-533c-200 0-311 114-311 320 0 204 114 321 311 321s310-117 310-321c0-206-110-320-310-320zM1862 1085h196V466h-136l2 433h-15l-4-5-213-428h-202v619h138l-5-436h15l4 5zM2531 455c-223 0-356 121-356 323 0 235 192 318 357 318 81 0 133-12 179-24l-7-113c-39 14-93 29-150 29-133 0-223-84-223-210 0-127 86-216 209-216 55 0 106 13 158 40l12-117c-50-14-114-30-179-30zM2849 1085h441V983h-290V820h264V718h-264V568h280V466h-431zM3652 760h-53V568h53c95 0 115 52 115 95 0 44-20 97-115 97zm-204 325h151V862h75c153 0 244-73 244-196 0-139-85-200-277-200h-193v619zM4147 1085h152V573h157V466h-466v107h157zM4592 1082h149V311h-149zM4898 1082h154V747h310V640h-310V419h324V311h-478z"
      />
    </svg>
  );
};

const ConceptifIcon = Icon;
export default ConceptifIcon;
